import { GetBodyCustomerVehicleImagesQueryParamsType } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyCustomerVehicleImages/getBodyCustomerVehicleImagesQuery.type';
import { getBodyCustomerVehicleImagesQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyCustomerVehicleImages/getBodyCustomerVehicleImagesQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getBodyCustomerVehicleImagesQueryOptions = (
  params: GetBodyCustomerVehicleImagesQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['bodyCustomerVehicleImages', params],
    queryFn: () => getBodyCustomerVehicleImagesQueryFunction(params),
    enabled: true,
  });
};
